<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="collage-wrapper">
    <img [src]="galleryImageUrl" alt="Gallery" class="collage-image" />
    <div class="overlay">
        <div class="title">Gallery</div>
        <div class="arrow">&rarr;</div>
    </div>
</div>